export default "assets/mail-f0379dc6.svg";